import {store} from 'store';

export function create(activity) {
  if (activity.name && activity.name.trim()) {
    update(activity);
  }
}

export function update(activity, options) {
  store.dispatch({
    type: 'ACTIVITIES_UPDATE',
    activity,
    ...options,
  });
}

export function updateStatus({ id, contextDate, subtask, uncomplete, retroperspective, ...data }) {
  if (!id) {
    throw 'id not defined';
  }
  store.dispatch({
    type: subtask ? 'ACTIVITIES_SUBTASK_STATUS_UPDATE' : 'ACTIVITIES_STATUS_UPDATE',
    id,
    contextDate,
    data,
    subtask,
    uncomplete,
    retroperspective
  });
}

export function removeImages(images) {
  store.dispatch({
    type: 'FILES_REMOVE',
    files: images
  });
}

export function duplicate({ id, ...activity }) {
  if (!id) {
    throw 'Target ID is missing';
  }
  store.dispatch({
    type: 'ACTIVITIES_DUPLICATE',
    referenceId: id,
    activity,
  });
}

export function attach({currentTarget}, {id}) {
  if (currentTarget.dataset.id && id) {
    store.dispatch({
      type: 'ACTIVITIES_UPDATE_PARENT',
      source_id: id,
      goal_id: currentTarget.dataset.id
    });
  }
}

export function reschedule({ id, date, time, duration, occurance, contextDate }) {
  if (occurance && occurance.duration == 24*60 && time) {
    duration = 0;
  }
  store.dispatch({
    type: 'ACTIVITIES_RESCHEDULE',
    id, date, time, duration, occurance, contextDate,
  });
}

export function toggle({ id, subtask }) {
  store.dispatch({
    type: subtask ? 'ACTIVITIES_TOGGLE_SUBTASK' : 'ACTIVITIES_TOGGLE',
    id,
    subtask,
  });
}

export function hold({ id }) {
  store.dispatch({
    type: 'ACTIVITIES_HOLD',
    id,
  });
}

export function remove({ id }) {
  store.dispatch({
    type: 'ACTIVITIES_DELETE',
    id,
  });
}
